module.exports = __webpack_public_path__ + "static/media/pink.840a49a3.png";